import * as React from 'react';
function useCanvas() {
    var ref = React.useRef(null);
    if (ref.current)
        return ref.current;
    var canvas = document.createElement('canvas');
    ref.current = canvas.getContext('2d');
    return ref.current;
}
export default useCanvas;
